import axios from 'axios';

import { logError } from '../../infrastructure/error-handling.js';

class CommunityPageService {
	getPageData(language) {
		return axios
			.get(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/singletons/get/community?lang=${language}`,
			)
			.then(res => res.data)
			.catch(logError);
	}
}

export default new CommunityPageService();
